export default "__VITE_ASSET__1a4f3756__"